module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_8019.cdd27205.png";